var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PickersLayoutContentWrapper, PickersLayoutRoot, pickersLayoutClasses, usePickerLayout, } from '@mui/x-date-pickers/PickersLayout';
import React from 'react';
import { Box } from '@mui/material';
import { InnerTimePicker } from './InnerTimePicker/InnerTimePicker';
import { calendarWidth } from '../../themes/light/components/MuiPickersLayout';
export function DateTimePickerLayout(props) {
    var _a = usePickerLayout(props), content = _a.content, actionBar = _a.actionBar, shortcuts = _a.shortcuts;
    return (React.createElement(PickersLayoutRoot, { ownerState: props, className: pickersLayoutClasses.root },
        shortcuts,
        React.createElement(PickersLayoutContentWrapper, { className: pickersLayoutClasses.contentWrapper },
            content,
            props.view !== 'month' && props.view !== 'year' && (React.createElement(Box, { width: calendarWidth, px: 2, mx: "auto" },
                React.createElement(InnerTimePicker, __assign({}, props)))),
            actionBar)));
}
